<template>
  <re-avatar
    color="primary"
    :icon="getIconName(row.building_type)"
  />
  <div class="column q-ml-md">
    <p
      v-if="row.building_type"
      class="q-mb-sm text-body1"
    >
      {{ $t('value.' + row.building_type) }}
    </p>

    <p class="q-mb-none text-body2">
      {{ value }}
    </p>
  </div>
</template>
<script setup>
import { useOptionsFormatter } from '@/composables/optionsFormatter'

const { buildingTypeOptions } = useOptionsFormatter()

// don't automatically insert attrs in root div:
defineOptions({ inheritAttrs: false })

defineProps({
  row: {
    type: Object,
    required: true,
  },
  value: {
    type: String,
    default: null,
  },
})

function getIconName(buildingType) {
  const opt = buildingTypeOptions.value.find((o) => o.value === buildingType)
  return opt ? opt.icon : 'mdi-help'
}
</script>
